"use client";

import { useContext } from "react";
import { FormContext } from "@/contexts/FormDataContext";
import { useTranslation } from "@/hooks/useTranslation";

const useServices = () => {
  const { t } = useTranslation();
  const { servicesDetails } = useContext(FormContext)!;

  const getServicePrice = (serviceName: string): number | null => {
    const service = servicesDetails.find((service: any) => service.pdf?.name === serviceName);
    return service?.total || null;
  };

  const getTime = (serviceName: string): string | null => {
    const match = serviceName.match(/_(\d+)([DW])-/);
    if (!match) return null;
    const [, number, unit] = match;

    const unitMap: Record<string, string> = {
      D: "days",
      W: "weeks",
    };

    return `${number} ${t(unitMap[unit])}`;
  };

  return { getServicePrice, getTime };
};

export default useServices;
